const translations = {
  Personal_information: "Informações Pessoais",
  Contact: "Contato",
  Address: "Endereço",
  Financial_References: "Referências Financeiras",
};

export function normalize(str) {
  return String(str || "").trim().toLowerCase();
}

export function buildVariablesByCategory(apiItems) {
  return (apiItems || []).reduce((acc, item) => {
    const category = translations[item.category] || item.category || "Outros";
    const variableName = item.variableName || item.value || item.variable;
    if (!variableName) return acc;
    if (!acc[category]) acc[category] = [];
    acc[category].push(variableName);
    return acc;
  }, {});
}

export function flattenVariables(variablesByCategory) {
  return Object.values(variablesByCategory || {}).flat();
}

export function validateStep1(form) {
  const errors = {};

  if (!form.title) errors.title = "Campo obrigatório";
  if (!form.url) errors.url = "Campo obrigatório";

  return errors;
}

export function validateBeforeSubmit(form, dataR) {
  const errors = validateStep1(form);

  const variables = (dataR || []).map((item) => ({
    field: item.field,
    variable: item.variable || null,
  }));

  const emptyCount = variables.filter((x) => !x.variable).length;

  const hasChannel =
    variables.some((x) => x.variable === "WhatsApp") ||
    variables.some((x) => x.variable === "Email");

  return {
    errors,
    variables,
    emptyCount,
    hasChannel,
  };
}
